import React from 'react';
import { Toaster } from 'react-hot-toast';

const NotificationHandler = () => {
    return (
        <Toaster
            position="top-right"
            toastOptions={{
                // Define default options
                className: '',
                duration: 5000,
                style: {
                    background: '#1a1a1c',
                    color: '#fff',
                    border: '1px solid #383838',
                },
                // Default options for specific types
                success: {
                    duration: 3000,
                    theme: {
                        primary: 'green',
                        secondary: 'black',
                    },
                },
                 error: {
                    duration: 5000,
                },
            }}
        />
    );
};

export default NotificationHandler;